/* jshint ignore:start */
import React from 'react';

const ErrorBanner = () => {
    return (
      <div className="row mt-2">
        <div className="col-sm-12 col-md-12 col-lg-12 col-12 alert-height">
          <div className="alert alert-danger text-center">
            <strong>No Videos found</strong>
          </div>
        </div>
      </div>
    );
}

export default ErrorBanner;
